<template>
    <v-card class="mx-auto  type-card" max-width="400">
        <div class="d-flex block-icon">
            <v-card-subtitle>
                <strong>Sub no: </strong> #{{ data.number }}
            </v-card-subtitle>
            <v-card-subtitle>
                <strong>Price: </strong> €{{  data.total }}
            </v-card-subtitle>
        </div>
        <v-btn @click="show = !show" :class="{ 'open': show }"></v-btn>
        <v-expand-transition>
            <div v-show="show">
                <v-divider></v-divider>
                <v-card-text class="d-flex card-text">
                    <div>
                        <span><strong>Status:</strong></span>
                        <span>{{ data.status }}</span>
                    </div>
                    <div>
                        <span><strong>Delivery date:</strong></span>
                        <span>{{ data.delivery_date.length > 0 ? data.delivery_date  : 'N/A' }}</span>
                    </div>
                    <div>
                        <span><strong>No of meals:</strong></span>
                        <span>{{ data.dishes.length  }}</span>
                    </div>
                </v-card-text>
                <div class="row-btn" v-if="data.status != 'cancelled'">
                    <button class="btn btn-apply set-active" @click="reactiveOrder( data )">
                        Reactivate order
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M0.0149757 9.65619C0.116976 8.62719 0.944976 8.36919 1.84898 8.40319C4.26998 8.49519 13.503 9.03019 15.028 9.03019C13.826 8.05019 12.744 7.13019 11.622 6.26319C10.659 5.51819 9.62998 4.85819 8.66498 4.11519C7.68198 3.35819 7.66098 2.45219 8.53598 1.47419C9.32598 0.592188 10.056 0.827188 10.863 1.50419C12.007 2.46519 13.229 3.33319 14.391 4.27319C16.065 5.62619 17.747 6.97219 19.363 8.39219C20.337 9.24819 20.186 10.7892 18.966 11.8382C16.255 14.1682 13.492 16.4392 10.699 18.6702C10.33 18.9652 9.47698 19.1482 9.17498 18.9302C8.59698 18.5142 9.11398 18.0412 9.49798 17.6222C10.173 16.8862 10.78 16.0882 11.413 15.3182C11.39 15.4572 11.369 15.5922 11.405 15.3562C11.484 15.5832 11.441 15.4602 11.398 15.3362C12.544 14.0672 13.689 12.7982 14.887 11.4722C14.754 11.4312 5.96798 11.4032 1.76698 11.4252C0.241976 11.4332 -0.0790243 10.6062 0.0149757 9.65419V9.65619Z" fill="white"/>
                        </svg>
                    </button>               
                </div>
                  <div class="row-btn">
                        <button class="btn btn-apply" @click="openPopupOrder(data)">
                            View full order details
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M0.0149757 9.65619C0.116976 8.62719 0.944976 8.36919 1.84898 8.40319C4.26998 8.49519 13.503 9.03019 15.028 9.03019C13.826 8.05019 12.744 7.13019 11.622 6.26319C10.659 5.51819 9.62998 4.85819 8.66498 4.11519C7.68198 3.35819 7.66098 2.45219 8.53598 1.47419C9.32598 0.592188 10.056 0.827188 10.863 1.50419C12.007 2.46519 13.229 3.33319 14.391 4.27319C16.065 5.62619 17.747 6.97219 19.363 8.39219C20.337 9.24819 20.186 10.7892 18.966 11.8382C16.255 14.1682 13.492 16.4392 10.699 18.6702C10.33 18.9652 9.47698 19.1482 9.17498 18.9302C8.59698 18.5142 9.11398 18.0412 9.49798 17.6222C10.173 16.8862 10.78 16.0882 11.413 15.3182C11.39 15.4572 11.369 15.5922 11.405 15.3562C11.484 15.5832 11.441 15.4602 11.398 15.3362C12.544 14.0672 13.689 12.7982 14.887 11.4722C14.754 11.4312 5.96798 11.4032 1.76698 11.4252C0.241976 11.4332 -0.0790243 10.6062 0.0149757 9.65419V9.65619Z" fill="white"/>
                            </svg>
                        </button>               
                    </div>
            </div>
        </v-expand-transition>
    </v-card>
</template>

<script>

import { url } from '@/api/api.js'

export default {
    name: 'cardInfo',
    props: ['data', 'editPlan', 'mainProductsAll', 'breakfastProductsAll', 'snacksProductsAll'],
    data: () => ({
        show: false,
        oldPlan: {}
    }),
    emits: ['update:visible', 'getOrderdishes'],
    methods: {
        reactiveOrder( data ) {
            //this.$store.dispatch('reactiveOrder', { data });
            
            window.location.href = url + "/account/view-subscription/" + data.number;
        },
        openPopupOrder( val) {  
                
            this.$emit( 'update:visible', true );
            this.$emit( 'getOrderdishes', val );
        },
        getDishes(Products, dishes, countDays) {
            let res = [];
            let start = 0;

            if (dishes) {
                let step = dishes.length / countDays;

                this.weeklyPlan.forEach(
                    (day, i) => {
                        if (day.view == true) {
                            start = i;
                            return;
                        }
                    }
                );

                if (dishes.length > 0 && Products.length > 0) {

                    for (var j = start * step; j < (start + 1) * step; j++) {
                        for (var i = 0; i < Products.length; i++) {
                      
                            if (Products[i].ID == dishes[j].dish_id) {
                                res.push(Products[i]);
                            }
                        }
                    }
                }

                this.$store.commit('viewLoader', false);
            }
            return res;
        },
    },
    computed: {
        weeklyPlan() {
            let plans = this.$store.getters.weeklyPlan;
            plans = plans.filter((plan, index) => (index < this.countDays));

            return plans;
        },
        popupOrder() {
            return this.$store.getters.popupOrder;
        },
    },
    async beforeMount() {    
        this.oldPlan = this.editPlan;     
    },
    watch: {

    }
}
</script>

<style lang="stylus">

ul {
    list-style: none;
    margin: 0;
    padding: none;
}

.btn.set-active svg {
    transform: rotate(-90deg);
}

.past-orders {
    ul {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
        margin-top: 2rem;

        li {
            width: calc(50% - .5rem);            

            & > .v-card {
                position: relative;
                padding: 1rem 1rem 1rem 60px;
                color: #1D2433;
                font-family: 'Manrope', sans-serif;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
                box-shadow: none;
                border-radius: 10px;
                border: 2px solid #E1E6EF;
                background: #FFF;
                .block-icon {

                }
                &:after {
                   position: absolute;
                   content: ''
                   left: 20px;
                   top: 16px;
                   width: 31px;
                   height: 31px;
                   fill: #201747;
                   background-size: cover;
                }

                & > button {
                    position: absolute;
                    top: 0;
                    right: 0;
                    background: url(/src/assets/images/icons/Arrow-Down.svg) no-repeat center / 20px 20px;
                }

                .v-card-subtitle {
                    width: 45%;
                    display: flex;
                    flex-direction: column;
                    color: #1D2433;
                    opacity: 1;
                }

                &.show {
                    &:after {
                        fill: #685BC7;
                    }
                }

                &.type-card {
                    &:after {
                        background: url(/src/assets/images/icons/basket.svg) no-repeat center / 31px 31px;
                    }
                }

            }
        }
    }
}
.card-text {
    & > div {
        width: 30%;
        padding: 0;
        display: flex;
        flex-direction: column;
    }
}
</style>